var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "fieldset",
    {
      staticClass: "form-group custom-rating-group",
      attrs: { disabled: _vm.disabled },
    },
    [
      _vm.label ? _c("legend", [_vm._v(_vm._s(_vm.label))]) : _vm._e(),
      _vm._v(" "),
      _c(
        "span",
        { staticClass: "custom-rating" },
        [
          _vm._l(_vm.ratings, function (rating) {
            return [
              _c("input", {
                staticClass: "custom-rating-input",
                attrs: {
                  type: "radio",
                  name: "cutomRating" + _vm.unique,
                  id: "cutomRating" + _vm.unique + "Rate" + rating,
                },
                domProps: { value: rating, checked: _vm.value == rating },
                on: {
                  click: function ($event) {
                    return _vm.set(rating)
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "custom-rating-label",
                  attrs: {
                    title: _vm.__("rate ") + rating + "/" + _vm.max_rating,
                    for: "cutomRating" + _vm.unique + "Rate" + rating,
                  },
                },
                [_vm._v(_vm._s(rating) + " stars")]
              ),
            ]
          }),
          _vm._v(" "),
          _c("input", {
            attrs: { type: "hidden", name: _vm.name },
            domProps: { value: _vm.value },
          }),
        ],
        2
      ),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }